import { AUTH_DISABLED, AUTH_STORAGE_KEY } from './config';
import type { StoredAuth } from '@/models/auth';

export function loadStored(): StoredAuth | null {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as StoredAuth) : null;
  } catch {
    return null;
  }
}

export function saveTokens(accessToken: string, refreshToken: string, expiresIn: number): void {
  localStorage.setItem(
    AUTH_STORAGE_KEY,
    JSON.stringify({
      access_token: accessToken,
      refresh_token: refreshToken,
      expires_at: Date.now() + expiresIn * 1000,
    })
  );
}

export function clearStored(): void {
  localStorage.removeItem(AUTH_STORAGE_KEY);
}

export function getAccessToken(): string | null {
  if (AUTH_DISABLED) return null;
  const stored = loadStored();
  return stored?.access_token ?? null;
}
